module.exports = __webpack_public_path__ + "static/media/cnito_live_bg_mobile_xmas.429be5da.svg";